import React, { useEffect, useState } from "react";
import "../Bec/bec.scss";

import {
  Button,
  Card,
  CardTitle,
  CardText,
  CardSubtitle,
  CardGroup,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Alert,
} from "reactstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

import { Bar, Doughnut, Line } from "react-chartjs-2";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";

const calcularTasaYPrediccion = (
  anios,
  aniosB,
  setTasaPromedio,
  setPrediccion,
  setGraficoTasas,
  setGraficoValores
) => {
  const tasas = [];

  // Añadimos una tasa de 0 para el primer año
  tasas.push(0);

  // Calcula tasas año a año desde el segundo
  for (let i = 1; i < aniosB.length; i++) {
    const valorAnterior = aniosB[i - 1];
    const valorActual = aniosB[i];
    if (valorAnterior !== 0) {
      const tasa = (valorActual - valorAnterior) / valorAnterior;
      tasas.push(tasa);
    } else {
      tasas.push(0);
    }
  }

  // Promedio de tasas excluyendo la primera si quieres
  const tasasSinPrimero = tasas.slice(1);
  const tasaProm =
    tasasSinPrimero.reduce((acc, t) => acc + t, 0) / tasasSinPrimero.length;
  setTasaPromedio(tasaProm);

  // Predicción para el siguiente año
  const ultimoValor = aniosB[aniosB.length - 1];
  const predValor = ultimoValor * (1 + tasaProm);
  setPrediccion(predValor);

  // Datos para gráfico de tasas (porcentaje)
  const tasasPorAño = anios.map((anio, index) => ({
    anio,
    tasa: tasas[index],
  }));

  // Datos para el gráfico de valores incluyendo predicción
  const aniosConPrediccion = [
    ...anios,
    (parseInt(anios[anios.length - 1]) + 1).toString(),
  ];
  const valoresConPrediccion = [...aniosB, predValor];

  // Configuración del gráfico de tasas
  setGraficoTasas({
    labels: anios, // Incluye el primer año
    datasets: [
      {
        label: "Tasa de crecimiento (%)",
        data: tasasPorAño.map((item) => (item.tasa * 100).toFixed(2)),
        backgroundColor: "rgba(123, 125, 179, 0.7)",
        borderColor: "rgba(49, 51, 124, 0.7)",
        borderWidth: 3,
        hoverBackgroundColor: "rgba(123, 125, 179, 0.7)",
        hoverBorderColor: "rgba(49, 51, 124, 0.7)",
        fill: false,
      },
    ],
  });

  // Configuración del gráfico de valores
  setGraficoValores({
    labels: aniosConPrediccion,
    datasets: [
      {
        label: "Conteo de usuarios",
        data: valoresConPrediccion,
        backgroundColor: "rgba(185, 226, 194, 0.7)",
        borderColor: "rgba(29, 116, 48, 0.7)",
        borderWidth: 3,
        hoverBackgroundColor: "rgba(185, 226, 194, 0.7)",
        hoverBorderColor: "rgba(29, 116, 48, 0.7)",
        fill: false,
      },
    ],
  });
};

const Administrador = () => {
  // Estado
  const [dataRes, setDataRes] = useState([]);
  // const [dataRes2, setDataRes2] = useState([]);
  const [anios, setAnios] = useState([]);
  const [aniosB, setAniosB] = useState([]);
  const [ciudad, setCiudad] = useState([]);
  const [region, setRegion] = useState([]);
  const [pruLoData, setPruLoData] = useState([]);
  /////
  const [tasaPromedio, setTasaPromedio] = useState(null);
  const [prediccion, setPrediccion] = useState(null);
  const [graficoTasas, setGraficoTasas] = useState({});
  const [graficoValores, setGraficoValores] = useState({});

  // Función para obtener datos
  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  async function peticionResumenDatos() {
    try {
      const res = await axios.get(`${baseUrl}?action=getResumen`);
      // console.log("Datos recibidos:", res.data);
      setDataRes(res.data);
      // Años y conteos
      if (res.data.anios && Array.isArray(res.data.anios)) {
        const aniosArray = res.data.anios.map((item) => item.anio_sup_bec);
        const conteoArray = res.data.anios.map((item) =>
          parseInt(item.conteo, 10)
        );
        setAnios(aniosArray);
        setAniosB(conteoArray);
      }

      // Ciudades y regiones
      if (res.data.ciudades && Array.isArray(res.data.ciudades)) {
        setCiudad(res.data.ciudades.map((item) => item.ciu_sup_bec));
        setRegion(res.data.ciudades.map((item) => parseInt(item.conteo, 10)));
      }

      // Datos pru_lo
      if (res.data.pru_lo && Array.isArray(res.data.pru_lo)) {
        setPruLoData(res.data.pru_lo);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  }

  // Ejecutar al cargar
  useEffect(() => {
    peticionResumenDatos();
  }, []);
  useEffect(() => {
    if (anios.length > 1 && aniosB.length === anios.length) {
      calcularTasaYPrediccion(
        anios,
        aniosB,
        setTasaPromedio,
        setPrediccion,
        setGraficoTasas,
        setGraficoValores
      );
    }
  }, [anios, aniosB]);
  ////GRAFICO BARRAS
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    Title,
    Tooltip,
    ArcElement,
    LineElement,
    Tooltip,
    Legend
  );
  /////proyeccion opciones
  // Define las opciones fuera del estado o en un lugar adecuado
  const opcionesTasas = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Tasa de crecimiento anual (%)",
        font: {
          size: 24,
          weight: "bold",
        },
      },
    },
  };
  const opcionesValores = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Conteo de usuarios y predicción",
        font: {
          size: 24,
          weight: "bold",
        },
      },
    },
  };
  /////
  const data = {
    labels: anios,
    datasets: [
      {
        label: "Inscritos",
        backgroundColor: "rgba(49, 51, 124, 0.7)",
        borderColor: "rgb(49, 51, 124)",
        borderWidth: 3,
        hoverBackgroundColor: "rgba(49, 51, 124, 0.8)",
        hoverBorderColor: "rgba(49, 51, 124)",
        data: aniosB,
      },
    ],
  };
  const opciones = {
    maintainAspectRatio: false,
    responsive: true,
    ticks: {
      font: {
        size: 15,
        weight: "bold",
      },
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 15,
            weight: "bold",
          },
        },
      },
    },
  };
  /////GRAFICO PIE
  const dataPie = {
    labels: ciudad,
    datasets: [
      {
        label: "# miembros",
        data: region,
        backgroundColor: [
          "rgba(217, 83, 79, 0.6)",
          "rgba(10, 49, 67, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
        ],
        borderColor: [
          "rgba(217, 83, 79, 0.8)",
          "rgba(10, 49, 67, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        hoverBackgroundColor: [
          "rgba(217, 83, 79, 0.9)",
          "rgba(10, 49, 67, 0.9)",
          "rgba(255, 206, 86, 0.9)",
          "rgba(75, 192, 192, 0.9)",
          "rgba(153, 102, 255, 0.9)",
          "rgba(255, 159, 64, 0.9)",
        ],
        hoverBorderColor: [
          "rgba(217, 83, 79)",
          "rgba(10, 49, 67)",
          "rgba(255, 206, 86)",
          "rgba(75, 192, 192)",
          "rgba(153, 102, 255)",
          "rgba(255, 159, 64)",
        ],
        borderWidth: 3,
      },
    ],
  };
  const opcionesPie = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 15,
            weight: "bold",
          },
        },
      },
    },
  };

  ////Modal Proyeccion
  const [modalProy, setModalProy] = useState(false);
  const [alertVisible, setAlertVisible] = useState(true);
  const onDismiss = () => setAlertVisible(false);
  const abrirCerrarModalProyec = () => {
    // Aquí va el código para abrir el modalProy
    setModalProy(!modalProy);
  };

  return (
    <div id="main_content">
      <div className="tra">
        <CardGroup className="row g-3">
          {/* Primera tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                {/* Contenido principal */}
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Cuentas</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Becarios
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_usuarios !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_usuarios}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                  <CardText>
                    <Link
                      to="/Administrador/usuarios"
                      className="btn btn-success"
                    >
                      Ver
                    </Link>
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaUserGraduate />
                </div>
              </div>
            </Card>
          </div>
          {/* Segunda tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Cuentas</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Personal
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_personal !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_personal}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                  <CardText>
                    <Link
                      to="/Administrador/usuarios-adm"
                      className="btn btn-success"
                    >
                      Ver
                    </Link>
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaUserTie />
                </div>
              </div>
            </Card>
          </div>
          {/* Tercera tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                {/* Contenido principal */}
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Datos</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Postulantes
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_postulantes !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_postulantes}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                  <CardText>
                    <Link
                      to="/Administrador/postulantes"
                      className="btn btn-success"
                    >
                      Ver
                    </Link>
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaLevelDownAlt />
                </div>
              </div>
            </Card>
          </div>
          {/* Cuarta tarjeta */}
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Informes</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Entregados
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.total_informes !== undefined ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.total_informes}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                  <CardText>
                    <Link
                      to="/Administrador/informe2"
                      className="btn btn-success"
                    >
                      Ver
                    </Link>
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaReadme />
                </div>
              </div>
            </Card>
          </div>

          {/* Quinta tarjeta
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Card className="h-100" style={{ color: "black" }}>
              <div className="row g-0 h-100">
                <div className="col-8 d-flex flex-column justify-content-between p-2">
                  <CardTitle tag="h5">Fecha Entrega</CardTitle>
                  <CardSubtitle className="mb-2 text-muted" tag="h6">
                    Informes
                  </CardSubtitle>
                  <CardText>
                    {Object.keys(dataRes).length > 0 &&
                    dataRes.ultimo_fecha_ent &&
                    dataRes.ultimo_fecha_ent.fech_lit ? (
                      <b style={{ color: "rgb(33 33 185)" }}>
                        {dataRes.ultimo_fecha_ent.fech_lit}
                      </b>
                    ) : (
                      <span>No hay datos disponibles</span>
                    )}
                  </CardText>
                  <CardText>
                    <Button disabled className="btn-success">
                      Ver
                    </Button>
                  </CardText>
                </div>
                <div className="icono-tarjeta">
                  <FaIcons.FaRegCalendarCheck />
                </div>
              </div>
            </Card>
          </div> */}
        </CardGroup>
        {/* // */}
        <Row>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Histórico de registros:</CardTitle>
              <CardText
                className="text-center"
                style={{ color: "rgb(33 33 185)" }}
              >
                <b>Becarios</b>
              </CardText>
              <div style={{ width: "100%", height: "400px" }}>
                <Bar data={data} options={opciones} />
              </div>
            </Card>
          </Col>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Registro según región:</CardTitle>
              <CardText
                className="text-center"
                style={{ color: "rgb(33 33 185)" }}
              >
                <b>Becarios</b>
              </CardText>
              <div style={{ width: "100%", height: "400px" }}>
                <Doughnut data={dataPie} options={opcionesPie} />
              </div>
            </Card>
          </Col>
          <Col sm="4">
            <Card body>
              <CardTitle tag="h5">Actividades recientes:</CardTitle>
              <div className="table-responsive" style={{ height: "450px" }}>
                <Table id="tabl">
                  <thead id="stahead">
                    <tr className="text-center">
                      <th>#</th>
                      <th>Usuario</th>
                      <th>Detalle</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pruLoData.length > 0 ? (
                      pruLoData.map((usr, nu) => (
                        <tr className="text-center" key={usr.id_l}>
                          <td>{nu + 1}</td>
                          <td>{usr.usr_mod}</td>
                          <td>{usr.detalle}</td>
                          <td>{usr.fechaA}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No hay actividades recientes
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Alert
        color="info"
        isOpen={alertVisible}
        toggle={onDismiss}
        style={{
          maxWidth: "80vw", // utiliza unidad relativa vw para ancho
          position: "absolute",
          top: "50%",
          right: "0%",
          transform: "translate(-50%, -50%)",
          animation: "slideIn 0.8s forwards",
        }}
      >
        <span
          style={{
            cursor: "pointer",
            display: "flex", // Agregamos display: flex para alinear elementos
            alignItems: "center", // Centramos verticalmente los elementos
          }}
          onClick={() => abrirCerrarModalProyec()}
        >
          <FaIcons.FaChartLine />
          &nbsp; PROYECCIÓN &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </Alert>

      {/* Modal proyección*/}
      <Modal isOpen={modalProy} toggle={abrirCerrarModalProyec}>
        <ModalHeader className="header_mo">
          Proyección poblacional de becarios
        </ModalHeader>
        <ModalBody>
          <Card body>
            {/* Gráfico de tasas de crecimiento */}
            <div id="chartContainer" style={{ width: "100%", height: "" }}>
              <Line data={graficoTasas} options={opcionesTasas} />
            </div>
            {/* Mostrar tasa promedio y predicción */}
            {tasaPromedio !== null && (
              <div style={{ marginTop: "10px" }}>
                Tasa de crecimiento promedio: {(tasaPromedio * 100).toFixed(2)}%
              </div>
            )}
            {/* Gráfico de valores con predicción */}
            <div id="chartContainer" style={{ width: "100%", height: "" }}>
              <Line data={graficoValores} options={opcionesValores} />
            </div>
            {/* Mostrar predicción */}
            {prediccion !== null && (
              <div style={{ marginTop: "10px" }}>
                Predicción para el siguiente año: {prediccion.toFixed(0)}
              </div>
            )}
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            size="lg"
            onClick={() => abrirCerrarModalProyec()}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Administrador;
